module.exports = __webpack_public_path__ + "img/indexbanner.5606073f.png";